// Lightweight browser device fingerprinting.
// No external deps — combines stable, non-PII attributes into a SHA-256 hash.
// The raw attributes are also sent so IT can review context.

const sha256Hex = async (str) => {
  const enc = new TextEncoder().encode(str);
  const buf = await crypto.subtle.digest('SHA-256', enc);
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, '0')).join('');
};

// Small, stable canvas signature — text rendering varies by GPU/font stack.
const canvasSig = () => {
  try {
    const c = document.createElement('canvas');
    c.width = 220; c.height = 40;
    const ctx = c.getContext('2d');
    ctx.textBaseline = 'top';
    ctx.font = '14px "Arial"';
    ctx.fillStyle = '#f60';
    ctx.fillRect(120, 1, 62, 20);
    ctx.fillStyle = '#069';
    ctx.fillText('PrideGlobal-DeviceTrust 2026', 2, 15);
    return c.toDataURL().slice(-64); // last N chars are usually stable & short
  } catch {
    return '';
  }
};

export const collectFingerprint = async () => {
  const nav = navigator || {};
  const scr = window.screen || {};
  const attrs = {
    user_agent: nav.userAgent || '',
    platform: nav.platform || '',
    language: nav.language || '',
    hardware_concurrency: nav.hardwareConcurrency || null,
    device_memory: nav.deviceMemory || null,
    screen: `${scr.width || 0}x${scr.height || 0}x${scr.colorDepth || 0}`,
    color_depth: scr.colorDepth || null,
    timezone: (Intl.DateTimeFormat().resolvedOptions().timeZone) || '',
    canvas: canvasSig(),
  };
  const seed = [
    attrs.user_agent, attrs.platform, attrs.language,
    attrs.hardware_concurrency, attrs.device_memory,
    attrs.screen, attrs.timezone, attrs.canvas,
  ].join('|');
  const fingerprint = await sha256Hex(seed);
  // Persist locally so we can compare on re-verify without recompute (also survives navigator.userAgent shifts).
  try { localStorage.setItem('device_fingerprint', fingerprint); } catch {}
  const { canvas: _canvas, ...safeAttrs } = attrs;
  return { fingerprint, ...safeAttrs };
};

export const getStoredFingerprint = () => {
  try { return localStorage.getItem('device_fingerprint') || null; } catch { return null; }
};
